import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatFullDate'
})
export class FormatFullDatePipe implements PipeTransform {
  transform(value: number | string): string {
    if (!value) return '';

    const date = new Date(+value);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
}
